import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c0aa41a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./nutrition-step-one.scss?vue&type=style&index=0&id=3c0aa41a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0aa41a",
  null
  
)

export default component.exports